<template>
  <div v-if="shouldShow">
    <div class="epic-heading">
      <div class="epic-drag btn">
        <i class="far fa-bars dragEpic"></i>
      </div>
      <div class="epic-number">
        #{{ order }}
      </div>
      <div class="epic-title">
        <input v-model="stateEpicTitle" @blur="leftFocus" type="text" class="form-control" placeholder="Epic Heading"/>
      </div>
      <button @click="confirmDelete" type="button" class="btn epic-trash"><i class="far fa-trash"></i></button>
      <button @click="toggleCollapsed" type="button" :class="`btn epic-collapse ${localCollapse ? 'collapsed' : ''}`"><i :class="classForCollapseState"></i></button>
    </div><!-- /.epic-heading -->
            
    <draggable v-if="!localCollapse" v-model="stateUserStories" class="dragArea" :options="{group:'stories', ghostClass: 'ghost-class', handle: '.drag'}" @update="storiesReordered(epic.id)" @add="storiesAdded(epic.id)">
      <user-story v-for="(userstory, storyIndex) in epic.stories" :key="userstory.id" :userstory="userstory" :epic="epic" :parent-order="order" :epicIndex="index" :storyIndex="storyIndex"></user-story>
    </draggable>

    <div v-if="!localCollapse" class="add-story" @click="handleCreateUserStory(epic.id)">
      <span class="inner"></span>
    </div><!-- /.add-story -->
  </div>
</template>

<script>
  
  import draggable from 'vuedraggable'
  import UserStory from 'components/user-stories/UserStory.vue'
  import AppConstants from '@/support/app-constants'
  import { mapState, mapMutations, mapActions } from 'vuex'
  import { SET_SAVE_STATUS } from 'vx/mutations'
  import { notify } from 'utils'
  import { filter, findIndex, intersectionBy } from 'lodash'
  import { filters } from 'mixins'

  var Story = require('./../../models/story.js');

  export default {
    mixins: [filters],

    props: ['initialEpic', 'index'],

    components: {
      draggable,
      UserStory
    },

    data () {
      return {
        epic: this.initialEpic,
        newUserStory: new Story(),
        edit:false,
        localCollapse: true
      }
    },

    mounted () {
      var that = this

      this.$bus.$on('delete-user-story', (id) => {
        if (this.epic.id === id) {

          this.storiesReordered(this.epic.id)
        }
      })

      this.localCollapse = this.view_options.collapsed
    },

    computed: {
      ...mapState('settings/userstories', ['view_options', 'filters']),
      ...mapState('yodizproject', {
        project: 'single'
      }),
      ...mapState('epics', ['epics']),

      order () {
        return this.index + 1
      },

      classForCollapseState () {
        if (this.localCollapse) {
          return 'far fa-chevron-circle-down rotate'
        }

        return 'far fa-chevron-circle-down'
      },
      
      stateEpicTitle: {
        get() {
          return this.epics[this.index].title
        },

        set (value) {
          this.setEpicProperty({ property: `epics.${this.index}.title`, value })
        }
      },

      stateUserStories: {
        get () {
          return this.epic.stories
        },

        set (value) {
          this.setUserStories({ epicId: this.epic.id, userstories: value })
        }
      },
      
      shouldShow() {
        if (this.filtersApplied) {
          
          return filter(this.epic.stories, (item) => {
            var meetsGroups = true
            var meetsTags = true
            var meetsEstimation = true

            if (this.filters.selectedGroups.length > 0) {
              if (findIndex(this.filters.selectedGroups, existing => existing.id === item.group_id) < 0) {
                meetsGroups = false
              }
            }

            if (this.filters.selectedTags.length > 0) {
              if (intersectionBy(this.filters.selectedTags, item.tags, 'id').length === 0) {
                meetsTags = false
              }
            }

            if (this.filters.estimation.length > 0) {
              if (this.filters.estimation === 'Estimated') {
                meetsEstimation = item.estimate > 0
              } else if (this.filters.estimation === 'Missing Estimate') {
                meetsEstimation = item.estimate <= 0
              }
            }

            return (meetsGroups && meetsTags && meetsEstimation)
          }).length > 0
        } else {
          return true
        }
      },
    },

    watch: {
      'view_options.collapsed' : function(collapsed) {
        this.localCollapse = collapsed
      }
    },

    methods: {
      ...mapMutations('settings/app', [SET_SAVE_STATUS]),
      ...mapActions('epics', ['addUserStory', 'setUserStories', 'setEpicProperty', 'deleteEpic', 'reorderUserStories']),

      toggleCollapsed () {
        this.localCollapse = !this.localCollapse
      },

    	confirmDelete() {
        var that = this;

        this.$swal(
            {
              title: 'Confirm Delete', 
              html: 'Are you sure you want to delete EP #'+this.order + '?<br> this will delete all of the user stories under it.',
              type: 'question',
              showCancelButton: true,
              confirmButtonText: 'Delete',
            }).then(function() {
              that.handleDeleteEpic();
          }, function() {
          });

      },

      handleDeleteEpic () {
        this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

        return this.deleteEpic({
          docId: this.project.user_story_document_id,
          epicId: this.epic.id
        }).then((response) => {
          this.$bus.$emit('delete-epic', this.epic.id);
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
        }).catch((response) => {
          if (response.status.code == 422) {
              var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
              
              notify.error(firstValidationIssue)
              this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)
          } else {
              this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
          }
        })
      },

      leftFocus () {
        	var that = this;
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

            return client({path: '/user-story-document/'+this.project.user_story_document_id +'/epics/'+this.epic.id, entity: this.epic, method: 'PUT'}).then( 
                (response) => {
                    this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
                },
                (response) => {

                    if (response.status.code == 422) {
                        var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];
                        
                        notify.error(firstValidationIssue)
                        this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)
                    } else {
                        this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
                    }
                }
            )

        },
    	getEpic(epicId) {
        	return this.epics.find(x => x.id === epicId)
    	},

		storyOrderArray (epicId) {
			var storyOrderArray = []
			var epic = this.getEpic(epicId)
			var stories = epic.stories

			for (var i = 0; i < stories.length; i++) {
				var story = stories[i]
				storyOrderArray.push({id: story.id})
			}

			return {
			  stories: storyOrderArray
			}
    },

	  handleCreateUserStory (epicId) {
	        var that = this
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)
	        this.newUserStory.epic_id = epicId

          this.addUserStory({
            id: this.project.user_story_document_id,
            payload: this.newUserStory
          }).then((response) => {
            
            this.newUserStory = new Story()

            this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
          }).catch((error) => {

            this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
          })
	    },

    	saveUserStoryOrder (epicId) {
	        var that = this
	        var stories = this.epics.find(x => x.id === epicId).stories
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

          this.reorderUserStories({
            id: this.epic.id,
            payload: this.storyOrderArray(this.epic.id)
          }).then((response) => {

            this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
          }).catch((response) => {
            
            this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
          })
    	},

    	storiesReordered (epicId) {
        	this.saveUserStoryOrder(epicId)
    	},

    	storiesAdded (epicId) {
        	this.saveUserStoryOrder(epicId)
    	}
    }

  }

</script>

<style scoped>
  i.rotate {
    transform: rotate(180deg);
  }

  .dragArea .story-drop {
    min-height: 50px;
  }

  .ghost-class .user-story {
    opacity: 0.2;
    border: 2px dashed #000;
  }

  .ghost-class .epic-heading {
    opacity: 0.2;
    border: 2px dashed #000;
  }

</style>